<script lang="ts">
  import { Container, Row } from "sveltestrap";
  import BookmarkWidgets from "./BookmarkWidgets.svelte";
  import Browzer from "./Browzer.svelte";
  import Calender from "./Calender.svelte";
  import ContactUs from "./ContactUs.svelte";
  import Date from "./Date.svelte";
  import Earning from "./Earning.svelte";
  import EmployeeCart from "./EmployeeCart.svelte";
  import MobileClock from "./MobileClock.svelte";
  import New from "./New.svelte";
  import ProductCart from "./ProductCart.svelte";
  import Profile from "./Profile.svelte";
  import RecentActivity from "./RecentActivity.svelte";
  import Sale from "./Sale.svelte";
  import SocialMedia from "./SocialMedia.svelte";
  import Testimonial from "./Testimonial.svelte";
  import Weather from "./Weather.svelte";
  import { onMount } from "svelte";
  import PreLodaer from "../../../Layout/PreLoader/PreLodaer.svelte";
  let ispreloader:boolean = false;
  onMount(() => {
		setTimeout(() => {
			ispreloader = true;
		}, 1000);
	});
</script>
{#if !ispreloader }
<PreLodaer />
{/if}
<BookmarkWidgets />
<!-- Container-fluid starts-->
<Container fluid class="general-widget">
  <Row>
    <Earning />
    <Date />
    <MobileClock />
    <Weather />
    <Sale />
    <New />
    <Testimonial />
    <RecentActivity />
    <Profile />
    <SocialMedia />
    <Browzer />
    <ProductCart />
    <EmployeeCart />
    <Calender />
    <ContactUs />
  </Row>
</Container>
<!-- Container-fluid Ends-->
